import React, { useEffect, useState } from "react";
import { api, i18n } from "@/lib/api";

function detectLanguage() {
  const param = new URLSearchParams(window.location.search).get("lang");
  if (param === "es" || param === "en") return param;
  const stored = typeof localStorage !== "undefined" ? localStorage.getItem("pta_lang") : null;
  return stored === "es" ? "es" : "en";
}

export default function PublicTemplateGallery() {
  const [language] = useState(detectLanguage());
  const t = i18n[language] || i18n.en;
  const [state, setState] = useState({ loading: true, items: [], error: null });

  useEffect(() => {
    let active = true;
    api
      .listPublicTemplates()
      .then((r) => {
        if (active) setState({ loading: false, items: r.items || [], error: null });
      })
      .catch(() => {
        if (active) setState({ loading: false, items: [], error: "error" });
      });
    return () => {
      active = false;
    };
  }, []);

  const { loading, items, error } = state;
  const homeUrl = `${window.location.origin}/`;

  return (
    <div
      data-testid="public-gallery-page"
      style={{ minHeight: "100vh", maxWidth: 820, margin: "0 auto", padding: "3rem 1.5rem 5rem" }}
    >
      <div className="h-eyebrow" data-testid="public-brand">
        POCKET TA AI
      </div>
      <h1 className="h-display" data-testid="public-gallery-title" style={{ marginTop: "0.5rem" }}>
        {t.galleryTitle}
      </h1>
      <p className="txt-mute" style={{ marginTop: "0.5rem", maxWidth: 620 }}>
        {t.gallerySubtitle}
      </p>

      <a
        data-testid="public-gallery-cta-top"
        href={homeUrl}
        className="btn-link"
        style={{ display: "inline-block", marginTop: "1rem", color: "var(--ink)", borderBottom: "1px solid var(--ink-faint)" }}
      >
        {t.createAccount}
      </a>

      <div className="line-strong" style={{ margin: "1.75rem 0" }} />

      {loading && (
        <p className="txt-mute" data-testid="public-gallery-loading">
          {t.loading}
        </p>
      )}

      {!loading && error && (
        <p className="txt-danger" data-testid="public-gallery-error">
          {t.galleryError}
        </p>
      )}

      {!loading && !error && items.length === 0 && (
        <p className="txt-mute" data-testid="public-gallery-empty">
          {t.galleryEmpty}
        </p>
      )}

      {!loading && !error &&
        items.map((item) => (
          <div
            className="vault-row"
            key={item.public_share_slug}
            data-testid={`public-gallery-row-${item.public_share_slug}`}
          >
            <div>
              <div style={{ fontSize: "1.02rem", color: "var(--ink)" }}>
                {item.custom_document_name || item.document_title}
              </div>
              <div className="kbd" style={{ marginTop: "0.25rem" }}>
                {item.document_type}
                {item.created_at ? ` - ${new Date(item.created_at).toLocaleDateString()}` : ""}
              </div>
            </div>
            <a
              data-testid={`public-gallery-view-${item.public_share_slug}`}
              className="btn-link"
              href={`${window.location.origin}/template/${item.public_share_slug}`}
            >
              {t.viewTemplate}
            </a>
          </div>
        ))}

      <div className="line-strong" style={{ margin: "2.5rem 0 1rem" }} />
      <a
        data-testid="public-gallery-cta-bottom"
        href={homeUrl}
        className="btn-link"
        style={{ color: "var(--ink)", borderBottom: "1px solid var(--ink-faint)" }}
      >
        {t.createAccount}
      </a>
    </div>
  );
}
